import Input from "components/common/input";
import ToggleButton from "components/common/togglebutton";
import {
  addLcmHealthPlan,
  updateLcmHealthPlan,
} from "containers/lcm-healthplans/api";
import { Formik } from "formik";
import { lcmHealthPlanInitialValues } from "./lcmHealthPlanInitialValues";
import { lcmHealthPlanSchema } from "./lcmHealthPlanSchema";

const LcmHealthPlanForm = ({ healthPlan, handleClose, onSuccess }) => {
  const isEditMode = !!healthPlan;

  const onFormSubmit = async (values, { setSubmitting, setErrors }) => {
    setSubmitting(true);
    const payload = {
      health_plan: {
        ...(healthPlan?.id && { id: healthPlan.id }),
        name: values.name,
        auto_assignment: values.auto_assignment,
        status: values.status || "active",
      },
    };

    const response = healthPlan
      ? await updateLcmHealthPlan(payload)
      : await addLcmHealthPlan(payload);

    // if (!response) {
    //   toast(
    //     <CustomToast
    //       message="Failed to make changes"
    //       variant={alertVariants.DANGER}
    //     />
    //   );
    // }

    if (response?.health_plan) {
      onSuccess();
    } else if (response.errors) {
      setErrors({ ...response.errors });
    }

    setSubmitting(false);
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={lcmHealthPlanInitialValues(healthPlan)}
      validationSchema={lcmHealthPlanSchema(isEditMode)}
      onSubmit={onFormSubmit}
    >
      {({
        handleChange,
        values,
        errors,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => {
        return (
          <div className="question-modal">
            <hr className="custom-modal-line mt-0 " />
            <form className="form-main" onSubmit={handleSubmit}>
              <div className="input-flex row">
                <div>
                  <ToggleButton
                    label="Status"
                    handleChange={(name, value) => {
                      setFieldValue(name, !!value ? "active" : "inactive");
                    }}
                    value={values?.status === "active" ? 1 : 0}
                    name="status"
                    // disabled={currentQuestionEdit ? true : false}
                  />
                </div>
                <div className="col-sm-12">
                  <Input
                    handleChange={handleChange}
                    placeholder="e.g. Health Plan Name"
                    type="text"
                    label="Name"
                    value={values.name}
                    name="name"
                  />
                </div>
              </div>

              {/* <div className="input-flex row">
                <div className="col-sm-12 mt-2 pt-1">
                  <ToggleButton
                    label="Auto Assignment"
                    handleChange={(name, value) => {
                      setFieldValue(name, !!value);
                    }}
                    value={values.auto_assignment}
                    name="auto_assignment"
                  />
                </div>
              </div> */}

              <hr className="custom-modal-line mt-4" />

              <div className="action gap-2">
                <button
                  className="secondary-btn w-50"
                  type="button"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                {isSubmitting ? (
                  <button className="primary-btn w-50" type="button" disabled>
                    <span
                      className="spinner-grow spinner-grow-sm"
                      role="status"
                      aria-hidden="true"
                    />
                    Submitting...
                  </button>
                ) : (
                  <button
                    className="primary-btn w-50"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isEditMode ? "Save Changes" : "Add Health Plan"}
                  </button>
                )}
              </div>
            </form>
          </div>
        );
      }}
    </Formik>
  );
};

export default LcmHealthPlanForm;
